import ForwardToInboxOutlinedIcon from "@mui/icons-material/ForwardToInboxOutlined"
import MailOutlinedIcon from "@mui/icons-material/MailOutlined"
import ListItemIcon from "@mui/material/ListItemIcon"
import ListItemText from "@mui/material/ListItemText"
import Menu from "@mui/material/Menu"
import MenuItem from "@mui/material/MenuItem"

export default function SendEmailMenu({ anchorElem, onClose }) {
  function handleSoftClose() {
    onClose()
  }

  return (
    <Menu anchorEl={anchorElem} open={!!anchorElem} onClose={handleSoftClose}>
      <MenuItem onClick={() => onClose(SEND_REQUEST_TYPE.campaign)}>
        <ListItemIcon>
          <MailOutlinedIcon />
        </ListItemIcon>
        <ListItemText>Send Using Email Template</ListItemText>
      </MenuItem>
      <MenuItem onClick={() => onClose(SEND_REQUEST_TYPE.direct)}>
        <ListItemIcon>
          <ForwardToInboxOutlinedIcon />
        </ListItemIcon>
        <ListItemText>Send Directly</ListItemText>
      </MenuItem>
    </Menu>
  )
}

export const SEND_REQUEST_TYPE = {
  campaign: "campaign",
  direct: "direct",
}
